import {default as cx} from "classnames"

function SubHeader({title1, title2, tabs, icon, children, compact}) {
    return (
        // flex-grow-0 keeps the header from expanding vertically on full-page survey layouts.
        <div className="d-flex flex-row-fluid flex-grow-0 bg-light shadow-sm toolbar-fixed">
            <div className="container-fluid px-4 px-md-6">
                <div className={cx("d-flex flex-row-fluid", compact ? "py-3" : "py-4 py-md-5")}>
                    <div className="app-toolbar-wrapper d-flex flex-column flex-md-row flex-md-row-fluid align-items-stretch align-items-md-center gap-3 gap-md-4">
                        <div className="page-title d-flex flex-column justify-content-center gap-1 flex-fill me-md-3">
                            <div className="d-flex flex-row-fluid flex-wrap align-items-center">
                                {tabs && <div className="mt-4">{tabs}</div>}
                                <i className={cx("d-flex flex-column fas me-2 text-primary", icon, compact ? "fs-2x" : "fs-3x")}></i>
                                <h1
                                    className={cx(
                                        "d-flex flex-column text-dark fw-bold mb-0 justify-content-center",
                                        compact ? "fs-2" : "fs-3 fs-md-1"
                                    )}
                                >
                                    <span className="fs-6 text-gray-700">{title1}</span>
                                    {title2}
                                </h1>
                            </div>
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SubHeader
